// Real social media posts data from @eppshelps
export const mockSocialPosts = [
  {
    id: 1,
    platform: 'Instagram',
    image: 'https://scontent-lax3-1.cdninstagram.com/v/t51.2885-15/602217974_18553320946033876_4232576529553517213_n.heic?stp=dst-jpg_e35_p640x640_sh0.08_tt6',
    caption: 'Merry Christmas from all of us at Pollard Capital! We are truly grateful for the trust, support, and relationships we have built this year. Wishing you and your families peace, joy, and blessings this holiday season.',
    date: 'Dec 25, 2024',
    likes: 0
  },
  {
    id: 2,
    platform: 'Instagram',
    image: 'https://scontent-lax3-1.cdninstagram.com/v/t51.2885-15/589265083_18534264313014484_6108717432437386486_n.heic?stp=dst-jpg_e35_s640x640_sh0.08_tt6',
    caption: 'The staff at @EPPShelps extends our heartfelt thanks to all of our partners. From those serving on the front lines at food missions to those who welcomed us in to provide complimentary business and tax services for our local leaders, we are truly grateful.',
    date: 'Dec 3, 2024',
    likes: 0
  },
  {
    id: 3,
    platform: 'Instagram',
    image: 'https://scontent-lax3-1.cdninstagram.com/v/t51.2885-15/495274477_18493324927014484_4101070227056151035_n.jpg?stp=dst-jpg_e35_s640x640_sh0.08_tt6',
    caption: 'Parents of @dunleithdolphins! I am excited to announce my candidacy for the 2025-2026 School Governance Team (SGT) Parent Representative position!',
    date: 'Oct 22, 2024',
    likes: 0
  },
  {
    id: 4,
    platform: 'Instagram',
    image: 'https://scontent-lax3-2.cdninstagram.com/v/t51.2885-15/621453567_17976375785816803_5117991482375759891_n.jpg?stp=dst-jpg_e35_p640x640_sh0.08_tt6',
    caption: 'On this National Adopt A Shelter Pet Day, I want to honor Cocoa - the black Lab mix who came into my life when I was 6 and stayed by my side until I was a senior in college. He was more than a pet, he was family.',
    date: 'Oct 18, 2024',
    likes: 0
  },
  {
    id: 5,
    platform: 'Instagram',
    image: 'https://scontent-lax3-2.cdninstagram.com/v/t51.2885-15/623800443_18105173272773247_960273293056200423_n.jpg?stp=dst-jpg_e35_s640x640_sh0.08_tt6',
    caption: 'Happy Earth Day from all of us at EPPS Helps! Today we celebrate the beauty of our planet and the power of community in protecting it.',
    date: 'Apr 22, 2024',
    likes: 0
  },
  {
    id: 6,
    platform: 'Instagram',
    image: 'https://scontent-lax3-2.cdninstagram.com/v/t51.29350-15/471582865_1654268141863791_2865373873981391699_n.heic?stp=dst-jpg_e35_s640x640_sh0.08_tt6',
    caption: 'Wishing you a season filled with love, joy, and countless blessings. From all of us at Pollard Capital and EPPS Helps, Merry Christmas to you and your loved ones!',
    date: 'Dec 25, 2024',
    likes: 0
  }
];
